

























import { LanguageView } from "@/shared/models/languages";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

const flagImages = require.context('@/assets/images/flags/', false, /\.png$/)

@Component
export default class ScrollLoader extends Vue {
  @Prop({ default: false }) hideLabels!: boolean;
  @Prop({ default: false }) singleLine!: boolean;
  @Prop({ default: false }) dense!: boolean;
  @Getter("language/language") language?: string;
  @Getter("language/supportedLanguages") supportedLanguages?: LanguageView[];

  get lan() {
    return this.language;
  }

  imgSrc(lang: string) {
    return flagImages('./' + lang + ".png")
  }

  languageChange(e: string) {
    this.$store.dispatch('language/setLanguage', e);
  }
}
